import { useState } from "react";
import "./css/attachment.css";
import {
  CloudUpload,
  RemoveRedEyeOutlined,
  Close,
  FileCopyOutlined,
} from "@material-ui/icons";

function PreviewAttachment({ link, close }) {
  return (
    <div className="preview-overlay" onClick={close}>
      <div
        className="preview-attachment"
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="attachment-header">
          <button className="close-btn" onClick={close}>
            <Close size={22} />
          </button>
          <h3 className="attachment-title">Preview</h3>
        </div>

        <div className="attachment-body">
          <iframe src={link} title="Attachment Preview" />
        </div>
      </div>
    </div>
  );
}

export default function Attachment({ name, link, status, remove, upload }) {
  const [preview, setPreview] = useState(false);
  return link ? (
    <>
    <div className="attached-file">
      <div  onClick={() => setPreview(true)}>
        <FileCopyOutlined /> {name || ""}
      </div>
      <RemoveRedEyeOutlined onClick={() => setPreview(true)} className="icon eye" />
      <Close className="icon close" onClick={remove} />
    </div>
     {preview ? (
        <PreviewAttachment link={link} close={() => setPreview(false)} />
      ) : null}
      </>
  ) : (
      <div className="attachment-field">
        {status === "uploading" ? null : (
          <input accept="application/pdf" type="file" onChange={upload} />
        )}
        <span>
          <CloudUpload />{" "}
          {status === "uploading" ? "Uploading..." : "Upload Answer PDF"}
        </span>
      </div>
     
  );
}
